/*
  Should only ever be instanciated once.
  Builds a list of named styles.
  Provides get() and add() methods to retrieve a style from the list
    or add a new style to the list.
*/

import MultiPoint from '../node_modules/ol/geom/MultiPoint';

import makeStyle from './makeStyle.js' // What's the diff between calling this function directly vs calling it with "new"?
import colors from './util/colors.js'

function Styles(paramList) {

  // when editing a geom, the vertex handles are the multi-point feature below
  let mpoint = new MultiPoint([]); // create new mpoint only once rather than a new one on each change

  // list contains the default styles below plus styles in paramList
  this.list = {

    // for selected vector features while editing
    selectedStyle: makeStyle({
      circle: {
        radius: 3,
        stroke: {
          color: [224, 24, 224, 0.8],
          width: 3,
        }
      },
      geometry: (feature) => {
        let geom = feature.getGeometry();
        let geoms;
        let coordinates = [];
        if (geom.getType() === 'GeometryCollection') {
          geoms = geom.getGeometries()
        } else {
          geoms = [geom];
        }
        geoms.forEach(geo => {
          if (geo.getType() === 'Polygon') {
            // concat coordinates from each ring of the polygon
            geo.getCoordinates().forEach(ring => coordinates = coordinates.concat(ring))
          } else {
            coordinates = coordinates.concat(geo.getCoordinates());
          }
        });
        mpoint.setCoordinates(coordinates);
        return mpoint;
      }
    }),

    // for seleted parcel polygons
    selectedParcelPolyStyle: makeStyle({
      stroke: {
        color: 'rgba(255, 192, 0, 0.8)',
        width: 6
      }
    }),

    // for labeling site addresses of selected polygons
    labelPointStyle: makeStyle({
      text: {
        // overflow: overflow,
        textAlign: 'center',  //  (must be lower case)
        font: 'normal 14pt sans-serif',
        fill: {color: '#000'},
        // stroke: parseInt(fontOutlineWidth) ? new Stroke({color: fontOutlineColor, width: parseInt(fontOutlineWidth)}) : null
        stroke: {color: '#fff', width: 3},
        text: '',
      }
    }),

    // used to style parcel poly when its info panel div is hovered over
    hoverStyle: makeStyle({
      fill: {
        color: 'rgba(192, 192, 192, 0.5)',
      },
      stroke: {
        color: 'rgba(255, 192, 0, 0.8)',
        width: 6
      }
    }),

  } // this.list

  for (const styleName in paramList) {
    this.add(styleName, paramList[styleName]);
  }
}

/**
 * opts is an object of style properties to override
 */
Styles.prototype.get = function(styleName, opts) {
  if (styleName) {
    const style =  this.list[styleName]
    for (const opt in opts) {
      const prop = opts[opt]
      // console.log(opt, prop)
      switch (opt) {
        case 'fill':
          const fill = style.getFill()
          for (const key in prop) {
            let val = prop[key]
            if (key === 'color') fill.setColor(val)
          }
          break
        case 'stroke':
          const stroke = style.getStroke()
          for (const key in prop) {
            const val = prop[key]
            if (key === 'width') stroke.setWidth(val)
            if (key === 'color') stroke.setColor(val)
            if (key === 'lineDash') stroke.setLineDash(val)
          }
          break
        case 'text':
          const text = style.getText()
          for (const key in prop) {
            const val = prop[key]
            if (key === 'text') text.setText(val)
            if (key === 'font') text.setFont(val)
            if (key === 'placement') text.setPlacement(val)
            if (key === 'geom') text.setGeometry(val)
            if (key === 'repeat') text.setRepeat(val)
          }
          break
        case 'xy':
          if (!prop) {
            // console.warn('no prop in Styles xy')
          } else {
            style.getGeometry().setCoordinates(prop)
          }
          break
        case 'geom':
          // console.log('Stlyes.get.geom', prop)
          style.setGeometry(prop)
          break

      }
    }
    return style;
  }
};

Styles.prototype.makeStyle = makeStyle

Styles.prototype.add = function(styleName, params) {
  this.list[styleName] = this.makeStyle(params)
  return this.list[styleName];
};

Styles.prototype.colors = colors

export default Styles;
